import IconContentAppointment from '../assets/appointmentsСontent.svg';
import IconBanner from '../assets/banner.svg';
import IconContentFeatures from '../assets/benefitsContent.svg';
import IconContentBio from '../assets/bio.svg';
import IconContentFile from '../assets/blocks/color/file.svg';
import IconContentListing from '../assets/blocks/color/listing.svg';
import IconContentOverview from '../assets/blocks/color/overview.svg';
import IconContentRental from '../assets/blocks/color/rental.svg';
import IconContentSingleProduct from '../assets/blocks/color/singleProduct.svg';
import IconContentStats from '../assets/blocks/color/statistics.svg';
import IconContentTeam from '../assets/blocks/color/team.svg';
import IconContentTimeline from '../assets/blocks/color/timeline.svg';
import IconContentMenu from '../assets/blocks/menu/foodIcon.svg';
import IconContentBlog from '../assets/blogContent.svg';
import IconContacts from '../assets/contactsSection.svg';
import IconContentCoupons from '../assets/couponsContent.svg';
import IconContentForm from '../assets/customForm.svg';
import IconContentDonation from '../assets/donations.svg';
import IconContentEmail from '../assets/emailSection.svg';
import IconContentFaq from '../assets/faq.svg';
import IconContentFooter from '../assets/footerSection.svg';
import IconContentGallery from '../assets/gallerySection.svg';
import IconHeader from '../assets/header.svg';
import IconContentHighlights from '../assets/highlightsContent.svg';
import IconContentInstagram from '../assets/instagramDesign.svg';
import IconContentLook from '../assets/looks.svg';
import IconContentMap from '../assets/mapContent.svg';
import IconContentMusic from '../assets/music.svg';
import IconContentNFT from '../assets/nftDesign.svg';
import IconContentLink from '../assets/pageLink.svg';
import IconPageList from '../assets/pageList.svg';
import IconPromo from '../assets/promo.svg';
import IconContentRequest from '../assets/requestSection.svg';
import IconContentReviews from '../assets/reviewsContent.svg';
import IconSectionDigital from '../assets/sections/digitalSection.svg';
import IconContentPodcasts from '../assets/sections/earphones.svg';
import IconContentHTMLCode from '../assets/sections/htmlCode.svg';
import IconContentMembership from '../assets/sections/subscribe.svg';
import IconContentEvents from '../assets/sections/tickets.svg';
import IconContentTutorial from '../assets/sections/tutorial.svg';
import IconSettingsWallet from '../assets/sections/wallet.svg';
import IconSettingsShop from '../assets/shop.svg';
import IconContentShopify from '../assets/shopifyDesign.svg';
import IconContentSlider from '../assets/sliderSection.svg';
import IconSpacer from '../assets/spacer.svg';
import IconContentSplashScreen from '../assets/splashScreen.svg';
import IconContentTikTok from '../assets/tiktokDesign.svg';
import IconContentTimer from '../assets/timer.svg';
import IconContentTrust from '../assets/trust.svg';
import IconContentTwitch from '../assets/twitch.svg';
import IconContentTwitter from '../assets/twitter.svg';
import IconContentWelcomeMessage from '../assets/welcomeMessageContent.svg';
import IconContentYouTube from '../assets/youtubeDesign.svg';

export const pathTypes = {
  messages: 'messages',
  audience: 'audience',
  website: 'website/*',
  posts: 'posts/*',
  store: 'products/*',
  emailMarketing: 'email/*',
  socialPlanner: 'scheduler/*',
  shortLinks: 'short-links/*',
  accountSettings: 'account-settings',

  design: 'design',
  analytics: 'analytics',
  templates: 'templates',
  settings: 'settings/*',
  settingsProfile: 'profile',
  settingsAccount: 'account',
  settingsAiAssistant: 'ai-assistant',
  settingsEmail: 'email',
  socialIntegrations: 'social-integrations',
  settingsStorage: 'storage',
  settingsNotifications: 'notifications',
  settingsShop: 'shop',
  settingsPayments: 'payments',
  settingsAnalytics: 'analytics',
  settingsSeo: 'seo',
  settingsDomain: 'custom-domain',
  settingsWebhooks: 'webhooks',
  settingsCalendar: 'calendar-integrations',
  settingsSensitiveMaterial: 'sensitive-material',

  appointments: 'appointments',
  gallery: 'gallery',
  blog: 'blog',
  request: 'services',
  html: 'html',
  digital: 'digital',
  coupons: 'coupons',
  reviews: 'reviews',
  features: 'feature',
  highlights: 'highlight',
  slider: 'slider',
  twitch: 'twitch',
  youtube: 'youtube',
  nft: 'nft',
  tiktok: 'tiktok',
  music: 'music',
  twitter: 'twitter',
  welcome: 'welcome',
  map: 'map',
  contacts: 'contact',
  timer: 'timer',
  trust: 'trust',
  faq: 'faq',
  donations: 'donations',
  tips: 'tip',
  wallet: 'wallet',
  form: 'form',
  subscribe: 'subscribe',
  looks: 'looks',
  instagram: 'instagram',
  shop: 'shop',
  links: 'link',
  text: 'text',
  banner: 'banner',
  spacer: 'spacer',
  header: 'header',
  promo: 'promo',
  footer: 'footer',
  splash: 'splash',
  courses: 'courses',
  ecommerce: 'ecommerce',
  events: 'events',
  membership: 'membership',
  podcast: 'podcast',
  etsy: 'etsy',
  shopify: 'shopify',
  spring: 'spring',
  promobar: 'promobar',
  splashScreen: 'splash',
  pricing: 'pricing',
  file: 'file',
  pageList: 'page-list',
  stat: 'stat',
  menu: 'menu',
  listing: 'listing',
  overview: 'overview',
  rental: 'rental',
  singleProduct: 'single-product',
  team: 'team',
  timeline: 'timeline',
  timetable: 'timetable',
  unlock: 'unlock',
};

export const routes = {
  index: '/*',
  productItem: '/product/:id',
  item: '/item/:id',
  blogItem: '/blog/:id',
  appointment: 'appointments/*',
  gallery: 'gallery/*',
  blog: 'blog/*',
  services: 'services/*',
  html: 'html/*',
  digital: 'digital/*',
  coupons: 'coupons/*',
  reviews: 'reviews/*',
  features: 'feature/*',
  highlights: 'highlight/*',
  slider: 'slider/*',
  twitch: 'twitch/*',
  youtube: 'youtube/*',
  nft: 'nft/*',
  tiktok: 'tiktok/*',
  music: 'music/*',
  twitter: 'twitter/*',
  welcome: 'welcome/*',
  trust: 'trust/*',
  map: 'map/*',
  contacts: 'contact/*',
  timer: 'timer/*',
  faq: 'faq/*',
  donations: 'donations/*',
  wallet: 'wallet/*',
  form: 'form/*',
  subscribe: 'subscribe/*',
  outfits: 'outfits/*',
  instagram: 'instagram/*',
  shop: 'shop/*',
  links: 'link/*',
  text: 'text/*',
  banner: 'banner/*',
  spacer: 'spacer/*',
  header: 'header/*',
  promo: 'promo/*',
  footer: 'footer/*',
  splash: 'splash/*',
  courses: 'courses/*',
  ecommerce: 'ecommerce/*',
  events: 'events/*',
  membership: 'membership/*',
  tier: 'tier/:id/',
  podcast: 'podcast/*',
  pricing: 'pricing/*',
  file: 'file/*',
  stat: 'stat/*',
  pageList: 'page-list/*',
  menu: 'menu/*',
  listing: 'listing/*',
  overview: 'overview/*',
  rental: 'rental/*',
  singleProduct: 'single-product/*',
  team: 'team/*',
  timeline: 'timeline/*',
  timetable: 'timetable/*',
  unlock: 'unlock/*',
};

export const sectionTypes = {
  splash: {
    type: 'splash',
    title: 'Splash screen',
    subtitle: 'Shows up while the page is loading',
    heading: '',
    path: pathTypes.splash,
    icon: IconContentSplashScreen,
  },
  promo: {
    type: 'promo',
    title: 'Promo bar',
    subtitle: 'A banner at the top of the website',
    heading: '',
    path: pathTypes.promo,
    icon: IconPromo,
  },
  header: {
    type: 'header',
    title: 'Header',
    subtitle: 'Enlarged featured image or video on your page',
    heading: '',
    path: pathTypes.header,
    icon: IconHeader,
  },
  footer: {
    type: 'footer',
    title: 'Footer',
    subtitle: 'Footer of your page',
    heading: '',
    path: pathTypes.footer,
    icon: IconContentFooter,
  },
  spacer: {
    type: 'spacer',
    title: 'Spacer',
    subtitle: 'Add spacer to header',
    heading: '',
    path: pathTypes.spacer,
    icon: IconSpacer,
  },
  banner: {
    type: 'banner',
    title: 'Banner',
    subtitle: 'About yourself/company',
    heading: '',
    path: pathTypes.banner,
    icon: IconBanner,
  },
  text: {
    type: 'text',
    title: 'Text',
    subtitle: 'Write anything about yourself/company',
    heading: '',
    path: pathTypes.text,
    icon: IconContentBio,
  },
  trust: {
    type: 'trust',
    title: 'Trust',
    subtitle: '+Share your partnership',
    heading: '',
    path: pathTypes.trust,
    icon: IconContentTrust,
  },
  links: {
    type: 'links',
    title: 'Links',
    subtitle: 'Links to anything',
    heading: '',
    path: pathTypes.links,
    createItemPath: 'links/item',
    icon: IconContentLink,
  },
  shop: {
    type: 'shop',
    title: 'Shop',
    subtitle: 'Sell physical and digital products',
    heading: '',
    path: pathTypes.shop,
    createItemPath: 'product',
    icon: IconSettingsShop,
    galleryType: 'product',
  },
  instagram: {
    type: 'instagram',
    title: 'Instagram',
    subtitle: 'Add media from Instagram',
    heading: '',
    path: pathTypes.instagram,
    icon: IconContentInstagram,
  },
  outfits: {
    type: 'looks',
    title: 'Looks',
    subtitle: 'Create your own product list',
    heading: '',
    path: pathTypes.looks,
    icon: IconContentLook,
  },
  subscribe: {
    type: 'subscribe',
    title: 'Subscribe',
    subtitle: 'Collect email addresses of page visitors',
    heading: '',
    path: pathTypes.subscribe,
    icon: IconContentEmail,
  },
  form: {
    type: 'form',
    title: 'Form',
    subtitle: 'Collect responses of page visitors',
    heading: '',
    path: pathTypes.form,
    icon: IconContentForm,
  },
  wallet: {
    type: 'wallet',
    title: 'Bank/Crypto wallet',
    subtitle: 'Add your credentials so your client can pay you',
    heading: '',
    path: pathTypes.wallet,
    icon: IconSettingsWallet,
  },
  tips: {
    type: 'tip',
    title: 'Tips',
    subtitle: 'Let fans send you small tips',
    heading: '',
    path: pathTypes.tips,
    icon: IconContentDonation,
  },
  donations: {
    type: 'donations',
    title: 'Donations',
    subtitle: 'Make a donation',
    heading: '',
    path: pathTypes.donations,
    createItemPath: 'donation/item',
    icon: IconContentDonation,
  },
  faq: {
    type: 'faq',
    title: 'FAQ',
    subtitle: 'Frequently asked questions',
    heading: '',
    path: pathTypes.faq,
    icon: IconContentFaq,
  },
  timer: {
    type: 'timer',
    title: 'Timer',
    subtitle: 'An active countdown clock which drives up sales',
    heading: '',
    path: pathTypes.timer,
    icon: IconContentTimer,
  },
  contacts: {
    type: 'contacts',
    title: 'Contacts',
    subtitle: 'Provide the way to communicate with you',
    heading: '',
    path: pathTypes.contacts,
    icon: IconContacts,
  },
  map: {
    type: 'map',
    title: 'Map',
    subtitle: 'Add map form google maps to your site',
    heading: '',
    path: pathTypes.map,
    icon: IconContentMap,
  },
  welcome: {
    type: 'welcome',
    title: 'Welcome message',
    subtitle: 'Add welcome message to your site',
    heading: '',
    path: pathTypes.welcome,
    icon: IconContentWelcomeMessage,
  },
  twitter: {
    type: 'twitter',
    title: 'Twitter',
    subtitle: 'Add post from Twitter',
    heading: '',
    path: pathTypes.twitter,
    icon: IconContentTwitter,
  },
  music: {
    type: 'music',
    title: 'Music',
    subtitle: 'Add your favorites songs',
    heading: '',
    path: pathTypes.music,
    icon: IconContentMusic,
  },
  tiktok: {
    type: 'tiktok',
    title: 'TikTok',
    subtitle: 'Add videos from TikTok',
    heading: '',
    path: pathTypes.tiktok,
    icon: IconContentTikTok,
  },
  nft: {
    type: 'nft',
    title: 'NFT',
    subtitle: 'Add NFT from OpenSea',
    heading: '',
    path: pathTypes.nft,
    icon: IconContentNFT,
  },
  youtube: {
    type: 'youtube',
    title: 'YouTube',
    subtitle: 'Add videos from YouTube',
    heading: '',
    path: pathTypes.youtube,
    createItemPath: 'youtube/item',
    icon: IconContentYouTube,
  },
  twitch: {
    type: 'twitch',
    title: 'Twitch',
    subtitle: 'Add streams from Twitch',
    heading: '',
    path: pathTypes.twitch,
    icon: IconContentTwitch,
  },
  slider: {
    type: 'slider',
    title: 'Slider',
    subtitle: 'Add slider',
    heading: '',
    path: pathTypes.slider,
    icon: IconContentHighlights,
  },
  highlight: {
    type: 'highlight',
    title: 'Highlights',
    subtitle: 'Add highlight images',
    heading: '',
    path: pathTypes.highlights,
    icon: IconContentSlider,
  },
  features: {
    type: 'features',
    title: 'Features',
    subtitle: 'Add description of your features',
    heading: '',
    path: pathTypes.features,
    icon: IconContentFeatures,
  },
  reviews: {
    type: 'reviews',
    title: 'Reviews',
    subtitle: 'Add reviews from your customers',
    heading: '',
    path: pathTypes.reviews,
    icon: IconContentReviews,
  },
  requests: {
    type: 'requests',
    title: 'Services',
    subtitle: 'Add services from your customers',
    heading: 'Make money with services',
    path: pathTypes.request,
    createItemPath: 'request/item',
    icon: IconContentRequest,
  },
  appointments: {
    type: 'appointments',
    title: 'Appointments',
    subtitle: 'Let visitors to book time on your calendar',
    heading: '',
    path: pathTypes.appointments,
    createItemPath: 'appointment/item',
    icon: IconContentAppointment,
  },
  gallery: {
    type: 'gallery',
    title: 'Gallery',
    subtitle: 'Add gallery',
    heading: '',
    path: pathTypes.gallery,
    icon: IconContentGallery,
  },
  blog: {
    type: 'blog',
    title: 'Blog',
    subtitle: 'Write about anything you want',
    heading: '',
    path: pathTypes.blog,
    createItemPath: 'blog/post',
    icon: IconContentBlog,
  },
  html: {
    type: 'html',
    title: 'HTML Code',
    subtitle: 'Add your own HTML code',
    heading: '',
    path: pathTypes.html,
    icon: IconContentHTMLCode,
  },
  digital: {
    type: 'digital',
    title: 'Digital products',
    subtitle: 'Sell a Digital Download etc.',
    heading: '',
    path: pathTypes.digital,
    createItemPath: 'digital/product',
    icon: IconSectionDigital,
    galleryType: 'digital',
  },
  coupons: {
    type: 'coupons',
    title: 'Coupons',
    subtitle: 'Add discount codes with the link to the website',
    heading: '',
    path: pathTypes.coupons,
    icon: IconContentCoupons,
  },
  courses: {
    type: 'courses',
    title: 'Course or Tutorial',
    subtitle: 'Add course or tutorial to the website',
    heading: '',
    path: pathTypes.courses,
    createItemPath: 'courses/course',
    icon: IconContentTutorial,
  },
  ecommerce: {
    type: 'ecommerce',
    title: 'Ecommerce platforms',
    subtitle: 'Add ecommerce to the website',
    heading: '',
    path: pathTypes.ecommerce,
    icon: IconContentShopify,
  },
  pricing: {
    type: 'pricing',
    title: 'Pricing',
    subtitle: 'Create unique menu with prices',
    heading: '',
    path: pathTypes.pricing,
    icon: IconContentShopify,
  },
  menu: {
    type: 'menu',
    title: 'Menu',
    subtitle: 'Create unique menu with prices',
    heading: '',
    path: pathTypes.menu,
    icon: IconContentMenu,
  },
  events: {
    type: 'events',
    title: 'Events or Tickets',
    subtitle: 'Create event and invite audience',
    heading: '',
    path: pathTypes.events,
    createItemPath: 'events/item',
    icon: IconContentEvents,
    galleryType: 'events',
  },
  membership: {
    type: 'membership',
    title: 'Membership',
    subtitle: 'Add membership to the website',
    heading: '',
    path: pathTypes.membership,
    createItemPath: 'membership/item',
    icon: IconContentMembership,
  },
  podcast: {
    type: 'podcast',
    title: 'Podcasts',
    subtitle: 'Add podcasts to the website',
    heading: '',
    path: pathTypes.podcast,
    createItemPath: 'podcast/item',
    icon: IconContentPodcasts,
  },
  file: {
    type: 'file',
    title: 'File',
    subtitle: 'Upload and share your files.',
    heading: '',
    path: pathTypes.file,
    icon: IconContentFile,
  },
  stat: {
    type: 'stat',
    title: 'Statistics',
    subtitle: 'Display key statistics for your page.',
    heading: '',
    path: pathTypes.stat,
    icon: IconContentStats,
  },
  pageList: {
    type: 'page-list',
    title: 'Page list',
    subtitle: 'Create your page list.',
    heading: '',
    path: pathTypes.pageList,
    icon: IconPageList,
  },
  listing: {
    type: 'listing',
    title: 'Listing',
    subtitle: 'Display property or item listings.',
    heading: '',
    path: pathTypes.listing,
    icon: IconContentListing,
  },
  overview: {
    type: 'overview',
    title: 'Overview',
    subtitle: 'Show business overview with details.',
    heading: '',
    path: pathTypes.overview,
    icon: IconContentOverview,
  },
  rental: {
    type: 'rental',
    title: 'Rental',
    subtitle: 'List rental items with pricing.',
    heading: '',
    path: pathTypes.rental,
    icon: IconContentRental,
  },
  singleProduct: {
    type: 'single-product',
    title: 'Single Product',
    subtitle: 'Feature a single product.',
    heading: '',
    path: pathTypes.singleProduct,
    icon: IconContentSingleProduct,
  },
  team: {
    type: 'team',
    title: 'Team',
    subtitle: 'Introduce your team members.',
    heading: '',
    path: pathTypes.team,
    icon: IconContentTeam,
  },
  timeline: {
    type: 'timeline',
    title: 'Timeline',
    subtitle: 'Display events on a timeline.',
    heading: '',
    path: pathTypes.timeline,
    icon: IconContentTimeline,
  },
  timetable: {
    type: 'timetable',
    title: 'Timetable',
    subtitle: 'Display weekly schedule.',
    heading: '',
    path: pathTypes.timetable,
    icon: IconContentTimeline,
  },
  unlock: {
    type: 'unlock',
    title: 'Unlock',
    subtitle: 'Gate content behind rules.',
    heading: '',
    path: pathTypes.unlock,
    icon: IconContentTimeline,
  },
};

export const storeSectionTypes = [
  sectionTypes.appointments.type,
  sectionTypes.shop.type,
  sectionTypes.courses.type,
  sectionTypes.digital.type,
  sectionTypes.events.type,
  sectionTypes.membership.type,
  // sectionTypes.links.type,
  sectionTypes.requests.type,
  sectionTypes.donations.type,
];

export const pathNavigate = {
  website: '/website',
  websiteDesign: '/website/design',
  websiteAnalytics: '/analytics',
  websiteSettings: '/website/settings',
  websiteTemplates: '/website/templates',

  products: '/products',
  productsEarning: '/products/earning',
  productsOrders: '/products/orders',

  audience: '/audience',

  email: '/email',

  scheduler: '/scheduler',
  schedulerIntegrations: '/social-planner/integrations',
  post: '/posts',
  postMembership: '/posts/membership',

  linkShortener: '/short-links',
  border: '/border',

  promo: '/website/promo',
  header: '/website/header',
  banner: '/website/banner',
  text: '/website/text',
  links: '/website/link',
  shop: '/website/shop',
  instagram: '/website/instagram',
  ecommerce: '/website/ecommerce',
  outfits: '/website/outfits',
  subscribe: '/website/subscribe',
  form: '/website/form',
  wallet: '/website/wallet',
  donation: '/website/donations',
  faq: '/website/faq',
  map: '/website/map',
  html: '/website/html',
  twitter: '/website/twitter',
  music: '/website/music',
  tiktok: '/website/tiktok',
  youtube: '/website/youtube',
  twitch: '/website/twitch',
  nft: '/website/nft',
  slider: '/website/slider',
  highlights: '/website/highlight',
  features: '/website/feature',
  reviews: '/website/reviews',
  appointment: '/website/appointments',
  gallery: '/website/gallery',
  blog: '/website/blog',
  services: '/website/services',
  contacts: '/website/contact',
  digital: '/website/digital',
  coupons: '/website/coupons',
  welcome: '/website/welcome',
  footer: '/website/footer',
  events: '/website/events',
  courses: '/website/courses',
  membership: '/website/membership',
  file: '/website/file',
  stat: '/website/stat',
  pageList: '/website/page-list',
  menu: '/website/menu',
  listing: '/website/listing',
  overview: '/website/overview',
  rental: '/website/rental',
  singleProduct: '/website/single-product',
  team: '/website/team',
  timeline: '/website/timeline',
  timetable: '/website/timetable',
  unlock: '/website/unlock',
  trust: '/website/trust',
};

export const sectionNames = {
  header: 'Header',
  text: 'Text',
  links: 'Link',
  subscribe: 'Subscribe',
  form: 'Form',
  contacts: 'Contacts',
  faq: 'FAQ',
  features: 'Feature',
  highlights: 'Highlight',
  slider: 'Slider',
  gallery: 'Gallery',
  blog: 'Blog',
  map: 'Map',
  shop: 'Shop',
  digital: 'Digital',
  appointments: 'Appointment',
  request: 'Request',
  donation: 'Donation',
  donations: 'Donation',
  tips: 'Tips',
  course: 'Course',
  courses: 'Course',
  events: 'Events',
  nft: 'NFT',
  wallet: 'Wallet',
  youtube: 'YouTube',
  twitter: 'Twitter',
  music: 'Music',
  twitch: 'Twitch',
  reviews: 'Review',
  coupons: 'Coupon',
  banner: 'Banner',
  spacer: 'Spacer',
  html: 'Html',
  timer: 'Timer',
  welcomeMessage: 'WelcomeMessage',
  promo: 'Promobar',
  tiktok: 'TikTok',
  splash: 'SplashScreen',
  membership: 'Membership',
  footer: 'Footer',
  instagram: 'Instagram',
  pricing: 'Pricing',
  file: 'File',
  stat: 'Statistics',
  pageList: 'Page list',
  menu: 'Menu',
  listing: 'Listing',
  overview: 'Overview',
  rental: 'Rental',
  singleProduct: 'Single Product',
  team: 'Team',
  timeline: 'Timeline',
  timetable: 'Timetable',
  unlock: 'Unlock',
  trust: 'Trust',
};

export const sectionFields = {
  common: {
    cta: 'cta',
    links: 'links',
    items: 'items',
    contacts: 'contacts',
    faq: 'faqs',
    products: 'products',
    courses: 'courses',
    wallets: 'wallets',

    titleSize: 'titleSize',
    titleLineHeight: 'titleLineHeight',

    title: 'headingTitle',
    titleColor: 'headingTextColor',
    description: 'headingDescription',
    textAlign: 'headingTextAlign',
    image: 'headingImage',
    headingDivider: 'headingDivider',

    sectionBackgroundColor: 'sectionBackgroundColor',
    sectionBackgroundColorRGBA: 'sectionBackgroundRGBA',
    sectionTextColor: 'sectionTextColor',
    sectionOpacity: 'sectionOpacity',
    sectionIsBorder: 'sectionIsBorder',
    sectionBorder: 'sectionBorder',
    sectionIsFullWidth: 'sectionIsFullWidth',
    sectionMargin: 'sectionMargin',
    sectionPadding: 'sectionPadding',
    sectionIsBackground: 'isSectionBackground',
    sectionBackgroundType: 'sectionBackgroundType',
    sectionBackgroundImage: 'sectionBackgroundImage',
    sectionGradientColor1: 'sectionGradientColor1',
    sectionGradientColor2: 'sectionGradientColor2',
    sectionGradientDirection: 'sectionGradientDirection',
    sectionGradientOffset: 'sectionGradientOffset',
    sectionBorderColor: 'sectionBorderColor',
    sectionIsShadowBorder: 'sectionIsShadowBorder',
    sectionShadowBorderColor: 'sectionShadowBorderColor',
    sectionIsShadow: 'sectionIsShadow',
    sectionShadow: 'sectionShadow',
    sectionShadowColor: 'sectionShadowColor',
    sectionShape: 'sectionShape',

    itemBackgroundColor: 'itemBackgroundColor',
    itemBackgroundColorRGBA: 'itemBackgroundRGBA',
    itemTextColor: 'itemTextColor',
    itemImageSize: 'itemImageSize',
    itemImageShape: 'itemImageShape',
    itemAlign: 'itemAlign',
    itemShadow: 'itemShadow',
    itemShadowColor: 'itemShadowColor',
    itemShape: 'itemShape',
    itemBorder: 'itemBorder',
    itemBorderColor: 'itemBorderColor',
    itemOpacity: 'itemOpacity',

    buttonTitle: 'buttonTitle',
    buttonText: 'buttonText',
    buttonColor: 'buttonColor',
    submitButtonText: 'submitButtonText',
    buttonBackgroundColor: 'buttonColor',
    buttonBGColor: 'buttonBackgroundColor',
    buttonTextColor: 'buttonTextColor',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonOpacity: 'buttonOpacity',
    buttonShape: 'buttonShape',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',

    viewType: 'viewType',
    view: 'view',
    layout: 'layout',
    display: 'display',
    channel: 'channel',
    url: 'url',
    content: 'content',
  },
  links: {
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonShape: 'buttonShape',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',

    defaultBtnTextAlign: 'defaultButtonTextAlign',
    defaultBtnRightIcon: 'defaultButtonRightIcon',
    defaultBtnIsGradient: 'defaultButtonIsGradient',
    defaultBtnGradientColor1: 'defaultButtonGradientColor1',
    defaultBtnGradientColor2: 'defaultButtonGradientColor2',
    defaultBtnGradientDirection: 'defaultButtonGradientDirection',
    defaultBtnGradientOffset: 'defaultButtonGradientOffset',

    defaultBtnBackgroundColor: 'defaultButtonBackgroundColor',
    defaultBtnTextColor: 'defaultButtonTextColor',
    defaultBtnOpacity: 'defaultButtonOpacity',
    defaultBtnHeight: 'defaultButtonHeight',
  },
  text: {
    title: 'title',
    textAlign: 'titleAlign',
    text: 'content',
    actionType: 'actionType',
    actionLinkId: 'actionLinkId',
    isTrim: 'isTrim',
    trimCount: 'trimCount',
    cta: 'cta',
    ctaActionType: 'ctaType',
    ctaSite: 'ctaSite',
    ctaSiteText: 'ctaSiteText',
    ctaBackgroundColor: 'ctaBackgroundColor',
    ctaBackgroundColorRGBA: 'ctaBackgroundRGBA',
    ctaTextColor: 'ctaTextColor',
    ctaIsBorder: 'ctaIsBorder',
    ctaOpacity: 'ctaOpacity',
    ctaItemId: 'ctaItemId',
    ctaPageId: 'ctaPageId',
    ctaBlockId: 'ctaBlockId',
    buttonBorder: 'ctaBorder',
    buttonBorderColor: 'ctaBorderColor',
    buttonShape: 'ctaShape',
    buttonShadow: 'ctaShadow',
    buttonShadowColor: 'ctaShadowColor',
  },
  form: {
    buttonTitle: 'buttonText',
    resultAction: 'formResultAction',
    resultData: 'formResultData',
    successMessage: 'formSuccessMessage',

    viewType: 'view',
    fields: 'formFields',

    isAddress: 'isFieldAddress',
    isComment: 'isFieldComment',
    isEmail: 'isFieldEmail',
    isName: 'isFieldName',
    isPhone: 'isFieldPhone',

    isAddressRequired: 'isFieldAddressRequired',
    isCommentRequired: 'isFieldCommentRequired',
    isEmailRequired: 'isFieldEmailRequired',
    isNameRequired: 'isFieldNameRequired',
    isPhoneRequired: 'isFieldPhoneRequired',

    buttonBackgroundColor: 'buttonBackgroundColor',
    buttonTextColor: 'buttonTextColor',
    buttonOpacity: 'buttonOpacity',
    buttonBorder: 'buttonBorder',
    buttonBorderColor: 'buttonBorderColor',
    buttonShadow: 'buttonShadow',
    buttonShadowColor: 'buttonShadowColor',
    buttonShape: 'buttonShape',
  },
  map: {
    code: 'embed',
    view: 'view',
    address: 'address',
    addressLink: 'addressUrl',
    addressButtonText: 'directionButtonText',
    addressIconType: 'directionButtonType',
    addressTitle: 'addressTitle',
    items: 'items',
  },
  shop: {
    items: 'custom',
    listView: 'listView',
    lists: 'lists',
    view: 'customView',
    layout: 'customLayout',
    postLayout: 'postLayout',
    postBackgroundColor: 'postBackgroundColor',
    postTextColor: 'postTextColor',
    postButtonBackgroundColor: 'postButtonBackgroundColor',
    postButtonTextColor: 'postButtonTextColor',
    postShadowColor: 'postShadowColor',
    postShadow: 'postShadow',
  },
  appointment: {
    token: 'calendlyAccessToken',
  },
  donation: {
    buttonBackgroundColor: 'buttonColor',
    buttonTextColor: 'buttonTextColor',
    icon: 'itemIcon',
    price: 'itemPrice',
    title: 'itemTitle',
    message: 'message',
    buttonTitle: 'buttonText',
    header: 'header',
    isComment: 'isComment',
    isName: 'isName',
    isPhone: 'isPhone',
    view: 'view',
    type: 'type',
    amounts: 'amounts',
    themeColor: 'themeColor',
    themeTextColor: 'rhemeTextColor',
  },
  nft: {
    items: 'nfts',
    layout: 'nftLayout',
    view: 'view',
  },
  youTube: {
    items: 'youTube',
    layout: 'layout',
    view: 'view',
  },
  twitter: {
    url: 'url',
  },
  banner: {
    height: 'height',
    bannerWidth: 'width',
    darkness: 'darkness',
    text: 'text',
    isText: 'isText',
    textColor: 'textColor',
    description: 'description',
    actionType: 'ctaType',
    ctaSite: 'ctaSite',
    ctaSiteText: 'ctaSiteText',
    ctaBackgroundColor: 'ctaBackgroundColor',
    ctaTextColor: 'ctaTextColor',
    ctaOpacity: 'ctaOpacity',
    ctaLinkId: 'ctaItemId',
    ctaBlockId: 'ctaBlockId',
    ctaBorder: 'ctaBorder',
    ctaBorderColor: 'ctaBorderColor',
    ctaShape: 'ctaShape',
    ctaShadow: 'ctaShadow',
    ctaShadowColor: 'ctaShadowColor',
    layout: 'widthView',
    heigthType: 'heightView',
    mediaHeader: 'mediaHeader',
    url: 'url',
    type: 'type',
  },
  spacer: {
    value: 'spacerValue',
  },
  timer: {
    position: 'position',
    label: 'label',
    title: 'title',
    backgroundColor: 'backgroundColor',
    textColor: 'textColor',
    opacity: 'opacity',
    icon: 'icon',
    linkId: 'linkId',
    type: 'type',
    timestamp: 'timestamp',
    tillDate: 'tillDate',
  },
};

export const defaultValues = {
  string: '',
  bool: false,
  boolTrue: true,
  boolFalse: false,
  number: 0,
  sectionMargin: 4,
  sectionPadding: 4,
  array: [],
  object: {},
  titleSize: 22,
  titleLineHeight: 120,
  textAlign: 'left',
  trimCount: 32,
  backgroundColor: '#ffffff',
  textColor: '#000000',
  shadowColor: '#000000',
  shadow: 'none',
  margin: 12,
  padding: 26,
  opacity: 0,
  buttonShape: 'round',
  buttonShadow: 'none',
  border: 'none',
  viewType: 1,
  resultAction: 1,
  view: 'card',
  blackColor: '#000000',
  whiteColor: '#ffffff',
  contacts: 'Contacts',
  align: 'left',
  imageShape: 'square',
  imageSize: 50,
  viewFeed: 'feed',
  display: '1',
  gradientColor1: '#B3F7EF',
  gradientColor2: '#F7D6E0',
  shape: 'round',

  cta: {
    text: 'Website',
  },

  slider: {
    layout: 'original',
    view: 'single',
    width: 'false',
  },

  faq: {
    view: 'feed',
  },
  gallery: {
    view: 'feed',
    layout: 2,
  },
  blog: {
    view: 'feed',
    layout: 4,
  },
  map: {
    code: 'feed',
    layout: 4,
  },
  donation: {
    view: 'card',
    type: 'donations',
    buttonTitle: 'Make a donation',
  },
  events: {
    view: 'squareEvents',
  },
  nft: {
    layout: 1,
    view: 'feed',
  },
  review: {
    layout: 'slider',
  },
  coupon: {
    view: 'compact',
  },
  banner: {
    layout: false,
    heightView: 'original',
    height: 200,
    darkness: 0,
    actionType: 0,
  },
  timer: {
    type: 1,
  },
};
